export const numberWithSpacesAsString = (value: number) => {
    const pattern: RegExp = /\B(?=(\d{3})+(?!\d))/g;
    return value.toString().replace(pattern, " ");
}